import React from 'react';
import { motion } from 'framer-motion';
import { useExperience } from '../../contexts/ExperienceContext';
import { needs } from '../../data/needs';
import { brand } from '../../data/palette';
import { productById } from '../../data/products';
import { Advance } from '../ui/Advance';
import { ProductGlyph } from '../ui/ProductGlyph';
import { Eyebrow, Stage, StageTitle } from '../ui/Stage';
const ease = [0.16, 1, 0.3, 1] as const;

/** The portfolio, finally — once the logic behind it is understood. */
export function FamilyStage() {
  const {
    next,
    direction,
    primaryNeed
  } = useExperience();
  return <Stage direction={direction} align="start" className="min-h-screen py-28 sm:py-32" labelledBy="family-title" data-id="element-238" data-mp="1n1je9p992qng">
      <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between" data-id="element-239" data-mp="1i98fwqu5rcx0">
        <div data-id="element-240" data-mp="uje48clkruec">
          <Eyebrow accent={brand.green} data-id="element-241" data-mp="uivz0qgxq5ua">The Filtek Family</Eyebrow>
          <StageTitle id="family-title" size="display-sm" className="mt-6 max-w-xl" data-id="element-242" data-mp="pl47hxk7clqm">
            One family. Five demands.
          </StageTitle>
        </div>
        <p className="label-mono text-[10px] text-mute" data-id="element-243" data-mp="378bbn2ffkobl">Need → Technique → Solution</p>
      </div>

      <div className="mt-14 grid gap-x-6 gap-y-10 md:grid-cols-5" data-id="element-244" data-mp="3bzjknxcum7o8">
        {needs.map((need, index) => {
        const product = productById(need.productId);
        const isFocus = need.id === primaryNeed;
        return <motion.div key={need.id} initial={{
          opacity: 0,
          y: 26
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.75,
          delay: index * 0.11,
          ease
        }} className="relative flex flex-col pt-5" data-id="element-245" data-mp="2jbnpwy6uapu3" data-mpi={index}>
              <span className="absolute inset-x-0 top-0 h-px" style={{
            backgroundColor: need.accent,
            opacity: isFocus ? 1 : 0.45
          }} aria-hidden="true" data-id="element-246" data-mp="2xang4aa03csd" />
              {isFocus && <span className="pointer-events-none absolute -inset-x-3 -bottom-4 top-0 -z-10" style={{
            backgroundColor: need.accent,
            opacity: 0.07
          }} aria-hidden="true" data-id="element-247" data-mp="ciczf8901b1x" />}

              <div className="flex items-center justify-between" data-id="element-248" data-mp="2ilqp079nvmtz">
                <span className="label-mono text-[9px]" style={{
              color: need.accent
            }} data-id="element-249" data-mp="2dme0zj7209pt">
                  {need.index}
                </span>
                {isFocus && <span className="label-mono text-[8px] text-enamel" data-id="element-250" data-mp="1puqhvng1a2y3">Your focus</span>}
              </div>

              <p className="mt-6 text-lg font-light leading-tight tracking-[-0.02em] text-enamel" data-id="element-251" data-mp="1zmmhx41ok34y">
                {need.label}
              </p>

              <p className="mt-4 border-t border-enamel/10 pt-4 text-sm font-light leading-relaxed text-mute" data-id="element-252" data-mp="1uv4fscnx7wie">
                {need.technique}
              </p>

              <div className="mt-6 flex items-end gap-4 border-t border-enamel/10 pt-6" data-id="element-253" data-mp="127ia8yv4uhsw">
                <ProductGlyph form={product.form} accent={need.accent} className="h-16 w-8 shrink-0" data-id="element-254" data-mp="3dulsi9jonak6" />
                <div data-id="element-255" data-mp="3inezl42miuzf">
                  <p className="text-base font-light leading-tight text-enamel" data-id="element-256" data-mp="34tw59u8hmsi2">
                    Filtek {product.shortName}
                  </p>
                  <p className="mt-2 text-xs font-light leading-snug text-mute" data-id="element-257" data-mp="39ts8vsd9whx3">
                    {product.descriptor}
                  </p>
                </div>
              </div>
            </motion.div>;
      })}
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.9,
      delay: 0.8
    }} className="mt-20 flex flex-col gap-10 border-t border-enamel/10 pt-12 lg:flex-row lg:items-end lg:justify-between" data-id="element-258" data-mp="5cfwdo72g0t8">
        <p className="max-w-xl text-[1.4rem] font-light leading-snug tracking-[-0.02em] text-enamel sm:text-[1.8rem]" data-id="element-259" data-mp="2c3njlseqtpyq">
          Different cases. Different demands.
          <span className="block text-mute" data-id="element-260" data-mp="2we868ezxq8xb">Fewer compromises.</span>
        </p>
        <Advance label="Go deeper" onClick={next} accent={brand.green} data-id="element-261" data-mp="2rni0h0nlk423" />
      </motion.div>
    </Stage>;
}